<template>

    <div ref="container" class="d-flex flex-column container">        
        <loading ref="loading"></loading>
        <header class="text-center">
            <br>
            <!-- <img src="img/icon-signup.svg" class="header-icon"> -->
            <h1 class="h2">{{ $t('translations.terms_conditions')}}</h1>
        </header>

        <div>
            <p>{{ $t('translations.terms_message', {"app_name": this.tBrand('app_name')})}}</p>
        </div>

        <div ref="editScroller" class="card-default-mtb-0 flex-grow-1-scroll">

            <local-error v-bind:inline='["terms"]'></local-error>

            <form>
                <div class="form-check pt-3 pb-2">
                    <input type="checkbox" class="form-check-input" id="terms" v-model='item.terms'>
                    <label class="form-check-label" for="terms"><span>{{ $t('translations.please_accept')}}</span> <a target="_blank" href="https://askmygp.uk/about-us/askmygp-end-user-licence-agreement-eula/">{{ $t('translations.terms_of_use')}}</a></label>
                    <inline-error type='terms'></inline-error>
                </div>

            </form>
        </div>
        <footer class="">
            <button v-on:click.prevent='updateItem($event)' class="btn btn-primary btn-block btn-round">
                {{ $t('translations.confirm')}}
            </button>
        </footer>

        <div class="card card-default">
            <div v-if='tBrandSetting("conf_show_licence_agreement")' class="mt-auto w-100 p-2">
                <p class="text-center"><strong><a target="_blank" href="https://askmygp.uk/about-us/askmygp-end-user-licence-agreement-eula/">{{ $t('translations.terms_of_use') }}</a></strong></p>
            </div>
            <div v-else class="pb-5"></div>
            <p style="line-height:1;"><small>{{ $t('translations.privacy_message_overview', {"app_name": this.tBrand("app_name"), "provider_generic_term": this.tBrand("provider_generic_term")}) }}</small></p>
        </div>
</div>

</template>

<script>

export default {

    props: {
        'route': {default: '/api/vp1/patients'},
        'event': {},
        'model': {},
        'elementname': {},
        'displayelement': {},
        'type': {},


    },
    data: function() {
        return {
            item: {},
            related_data: {},
            errors: []
        };
    },
    mounted() {
        //window.test123.testabc = 1;
        this.errors = [];
        this.resetItem();
        this.item.practice_code = this.$root.practice_code;
        this.item.locale = this.$root.locale;
        if(this.item.practice_code == null) {
            try {
                if(typeof localStorage === 'object') {
                    this.item.practice_code = localStorage.getItem('practice_code');
                }
            }
            catch(e) {

            }
        }
    },
    methods: {

        resetItem() {
            this.item = {};
            this.errors = [];
        },
        updateItem(event) {  
            this.setLoading(true);
            this.item.provider_id = window.provider_id;
            return axios.post(this.route + '/acceptTerms', this.item).then((res) => {
                this.$root.user.tc_agree_date = res.data.tc_agree_date;
                if(!this.$route.params.next) {
                    this.$route.params.next = "Profile";
                }

                this.$router.push({path: this.$route.params.next});
            }).catch((error) => {
                this.setLoading(false);
                this.handleError(error, "create");
                this.scrollFirstError();
            });
        },
    }
}

</script>
